module.exports = __webpack_public_path__ + "assets/img/01.d5b83ae2.png";